/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Retention_TitleInputs */

const da_privacy_retention_title = /** @type {(inputs: Privacy_Retention_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvor længe vi gemmer`)
};

/** @type {(inputs: Privacy_Retention_TitleInputs) => LocalizedString} */
const en_privacy_retention_title = da_privacy_retention_title;

/**

* @param {Privacy_Retention_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_retention_title = /** @type {((inputs?: Privacy_Retention_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Retention_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_retention_title(inputs)
	return /** @type {LocalizedString} */ ("Hvor længe vi gemmer")
});